var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_140200",
    "data-name": "Group 140200",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#de1515"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3008",
    "data-name": "Group 3008",
    transform: "translate(6.726 6.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_4ed3d25f5a20100efbeb33963636822c",
    "data-name": "4ed3d25f5a20100efbeb33963636822c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8491",
    "data-name": "Path 8491",
    d: "M10.08,11.12a.268.268,0,0,0-.379,0l-1.1,1.1c-.137.137-.84-.054-1.569-.783S6.111,10,6.251,9.866l1.1-1.1a.266.266,0,0,0,.078-.191.278.278,0,0,0-.078-.191L4.177,5.22a.268.268,0,0,0-.379,0l-.818.818c-.6.6-.632,1.66-.1,2.989a12.223,12.223,0,0,0,2.7,3.861c1.94,1.94,4.071,3.07,5.543,3.07a1.789,1.789,0,0,0,1.31-.471l.818-.818a.266.266,0,0,0,.078-.191.278.278,0,0,0-.078-.191Zm1.97,3.985c-.842.842-3.493,0-6.092-2.6a11.681,11.681,0,0,1-2.58-3.681c-.441-1.1-.447-1.98-.019-2.408l.627-.627L6.773,8.578l-.907.907c-.5.5.03,1.577.783,2.33S8.477,13.1,8.98,12.6l.907-.907,2.788,2.788ZM9.082,2.51a.269.269,0,1,0,0,.538,6.344,6.344,0,0,1,6.337,6.337.269.269,0,1,0,.538,0A6.882,6.882,0,0,0,9.082,2.51Z",
    transform: "translate(-2.408 -2.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8491_-_Outline",
    "data-name": "Path 8491 - Outline",
    d: "M11.118,16.05c-1.55,0-3.7-1.187-5.611-3.1a12.316,12.316,0,0,1-2.72-3.893c-.549-1.368-.506-2.467.121-3.093l.818-.818a.364.364,0,0,1,.515,0L7.413,8.315a.375.375,0,0,1,.106.259.363.363,0,0,1-.106.259l-1.1,1.1c-.077.086.08.73.783,1.433a2.418,2.418,0,0,0,1.358.8.133.133,0,0,0,.075-.013l1.1-1.1a.364.364,0,0,1,.515,0l3.17,3.167a.375.375,0,0,1,.106.259.363.363,0,0,1-.106.259l-.818.818A1.871,1.871,0,0,1,11.118,16.05ZM3.983,5.233a.171.171,0,0,0-.122.051L3.044,6.1c-.568.568-.6,1.593-.078,2.886a12.122,12.122,0,0,0,2.678,3.829c1.876,1.876,3.974,3.042,5.475,3.042a1.687,1.687,0,0,0,1.242-.443l.818-.818a.17.17,0,0,0,.05-.123.182.182,0,0,0-.052-.125l-3.168-3.165a.176.176,0,0,0-.244,0l-1.1,1.1a.287.287,0,0,1-.21.069A2.551,2.551,0,0,1,6.963,11.5,2.581,2.581,0,0,1,6.109,10a.285.285,0,0,1,.071-.21l1.1-1.1a.17.17,0,0,0,.05-.123.182.182,0,0,0-.052-.125L4.105,5.284A.171.171,0,0,0,3.983,5.233Zm7.128,10.279c-1.387,0-3.437-1.155-5.225-2.942a11.777,11.777,0,0,1-2.6-3.713c-.457-1.139-.456-2.054,0-2.512l.695-.695L6.905,8.574l-.975.975c-.442.442.051,1.463.783,2.194a2.89,2.89,0,0,0,1.742.952.614.614,0,0,0,.452-.169l.975-.975,2.923,2.923-.692.695A1.384,1.384,0,0,1,11.111,15.512ZM3.982,5.922l-.559.559c-.4.4-.386,1.241.04,2.3a11.583,11.583,0,0,0,2.559,3.649c1.753,1.753,3.75,2.886,5.089,2.886a1.2,1.2,0,0,0,.867-.287l.556-.559L9.883,11.823l-.839.839a.8.8,0,0,1-.588.226,3.078,3.078,0,0,1-1.878-1.009c-.807-.807-1.335-1.914-.783-2.466l.839-.839Zm11.7,3.824a.366.366,0,0,1-.365-.365A6.248,6.248,0,0,0,9.078,3.14a.365.365,0,0,1,0-.73,6.979,6.979,0,0,1,6.971,6.971A.366.366,0,0,1,15.684,9.746ZM9.078,2.6a.173.173,0,0,0,0,.346,6.44,6.44,0,0,1,6.433,6.433.173.173,0,1,0,.346,0A6.786,6.786,0,0,0,9.078,2.6Z",
    transform: "translate(-2.405 -2.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8492",
    "data-name": "Path 8492",
    d: "M26.219,9.52a.269.269,0,1,0,0,.538,4.453,4.453,0,0,1,4.448,4.448.269.269,0,1,0,.538,0A4.991,4.991,0,0,0,26.219,9.52Z",
    transform: "translate(-19.546 -7.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8492_-_Outline",
    "data-name": "Path 8492 - Outline",
    d: "M26.215,9.42A5.087,5.087,0,0,1,31.3,14.5a.365.365,0,0,1-.73,0,4.357,4.357,0,0,0-4.352-4.352.365.365,0,1,1,0-.73Zm4.717,5.255A.173.173,0,0,0,31.1,14.5a4.895,4.895,0,0,0-4.89-4.89.173.173,0,1,0,0,.346A4.549,4.549,0,0,1,30.759,14.5.173.173,0,0,0,30.932,14.675Z",
    transform: "translate(-19.542 -7.534)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8493",
    "data-name": "Path 8493",
    d: "M28.781,19.63a.269.269,0,1,0,.538,0,3.1,3.1,0,0,0-3.1-3.1.269.269,0,1,0,0,.538A2.568,2.568,0,0,1,28.781,19.63Z",
    transform: "translate(-19.546 -12.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8493_-_Outline",
    "data-name": "Path 8493 - Outline",
    d: "M29.046,19.991a.366.366,0,0,1-.365-.365,2.472,2.472,0,0,0-2.466-2.465.365.365,0,0,1,0-.73,3.2,3.2,0,0,1,3.2,3.2A.366.366,0,0,1,29.046,19.991Zm-2.831-3.369a.173.173,0,1,0,0,.346,2.664,2.664,0,0,1,2.658,2.658.173.173,0,0,0,.346,0A3.007,3.007,0,0,0,26.215,16.622Z",
    transform: "translate(-19.542 -12.658)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency);
export default __webpack_public_path__ + "static/media/emergency.bed8ac2120a9056d15af158a5fa337be.svg";
export { ForwardRef as ReactComponent };